"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionStorageF = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sessionStore_1 = require("../../utilities/sessionStore");
var createGetSessionStorageSuccessActionBase_1 = require("../../actionCreators/createGetSessionStorageSuccessActionBase");
var sessionConstants_1 = require("../../constants/sessionConstants");
var getSessionStorageF = function () {
    var sessionStorage;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                sessionStorage = sessionStore_1.sessionStore.get(sessionConstants_1.SESSION_STORAGE_KEY) || {};
                return [4 /*yield*/, (0, effects_1.put)((0, createGetSessionStorageSuccessActionBase_1.createGetSessionStorageSuccessActionBase)({
                        description: 'getSessionStorageF',
                        sessionStorage: tslib_1.__assign(tslib_1.__assign({}, sessionStorage), { isEndToEndTesting: !!sessionStorage.isEndToEndTesting }),
                    }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.getSessionStorageF = getSessionStorageF;
